enum FinancedSubjectTypeEnum {
    CASH = 'CASH',
    LIABILITY = 'LIABILITY',
    ORDER = 'ORDER',
    WALLET = "WALLET",
}

export default FinancedSubjectTypeEnum;
